import { endpoints } from '@rossum/api-client';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../lib/apiClient';

export const QUERY_KEY_DOCUMENT = 'document';

type Props = {
  enabled?: boolean;
  documentIds: number[];
};

export const useFetchDocuments = ({ documentIds }: Props) => {
  const query = { id: documentIds };
  return useQuery({
    queryKey: ['documents', 'list', query],
    queryFn: async () => {
      const response = await api.request(endpoints.documents.list(query));
      return response;
    },
    enabled: Boolean(documentIds.length),
  });
};
